// EditSubCategory.js

import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Button, Upload } from 'antd';
import { UploadOutlined, LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import ConfirmationModal from "../src/editCnfirmation/ConfirmationModal";

const EditCommonInfo = ({
  show,
  onHide,
  category,
}) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const token = localStorage.getItem('token');
  const [file, setFile] = useState("");
  const [uploadedOrganiserId, setUploadedOrganiserId] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const handleShowConfirmationModal = () => {
    setShowConfirmationModal(true);
  };

  const handleHideConfirmationModal = () => {
    setShowConfirmationModal(false);
  };
  useEffect(() => {
    if (show) {
      form.setFieldsValue(category);  // Assuming iconimage is part of the category data
    }
  }, [show, category, form]);

 

  const handleFileUpload = async (options) => {
    const { onSuccess, onError, file, onProgress } = options;
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        "https://api.starmallonline.com/api/v1/common/file",
        formData,
        {
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            onProgress({ percent: percentCompleted });
          },
          headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (response.status === 401 || response.status === 404 || !token) {
        navigate('/AdminLogin');
        return;
      }

      if (response.status === 200) {
        const uploadedId = response.data.organiserId;
        setUploadedOrganiserId(uploadedId);
        onSuccess("File uploaded");
      } else {
        onError("File upload failed");
      }
    } catch (error) {
      onError("File upload failed");
    }
  };

  const handleSave = async () => {
    try {
      const values = await form.validateFields();
      const requestData = {
        title: values.title,
        description: values.description,
        url: values.url,
        commoninfoid: category.commoninfoid,
        iconimage:uploadedOrganiserId,
      };

      const response = await axios.post(
        "https://api.starmallonline.com/api/v1/common/edit",
        requestData,
        {
          headers: {
            Authorization: 'Bearer ' + token,
            'Content-Type': 'application/json',
          },
        }
      );

      if (response.status === 401 || response.status === 404 || !token) {
        navigate('/AdminLogin');
        return;
      }

      if (response.status === 200) {
        // Handle successful save
        console.log("Event edited successfully");
        window.location.reload();
      } else {
        // Handle save failure
        console.error("Failed to edit event");
      }
    } catch (error) {
      // Handle validation errors or other issues
      console.error("Error during form submission", error);
    }
  };
  const handleConfirmSaveChanges = () => {
    handleHideConfirmationModal();
    // Proceed with saving changes
    handleSave();
  }; 
  return (
    <Modal
      title="Edit SocialMedia Icon"
      open={show}
      onCancel={onHide}
      footer={[
        <Button key="cancel" onClick={onHide}>
          Cancel
        </Button>,
        <Button key="save" type="primary" onClick={handleShowConfirmationModal} >
          Save
        </Button>,
      ]}
    >
      <Form form={form} layout="vertical">
        <Form.Item name="title" label="Title">
          <Input />
        </Form.Item>
        <Form.Item name="description" label="Description">
          <Input />
        </Form.Item>
        <Form.Item name="url" label="URL">
          <Input />
        </Form.Item>
        <Form.Item name="file" label="Upload Icon" valuePropName="file">
          <Upload
            customRequest={handleFileUpload}
            file={file}
            onChange={({ file }) => setFile(file)}
          >
            <Button icon={<UploadOutlined />} style={{ top: '0px', borderRadius: '0px' }}>Click to Upload</Button>
          </Upload>
        </Form.Item>
      </Form>
      <ConfirmationModal
        show={showConfirmationModal}
        onHide={handleHideConfirmationModal}
        onConfirm={handleConfirmSaveChanges}
      />
    </Modal>
  );
};



export default EditCommonInfo;
